import React from 'react';
import "../../../styles/Portal.css";
import "../../../styles/querysteps.css";

const NOK = () => {
    return <div>NOK</div>;
}


export default NOK;